module.exports = ".fintech-icons {\n  font-size: 14pt;\n  line-height: 2;\n}\n\n.fincol {\n  border: 1px solid #d8250d;\n  border-radius: 5px;\n  padding: 30px;\n  margin-top: 1em;\n}\n\n.fincol:hover {\n  border: 1px solid #d8250d;\n  border-radius: 5px;\n  padding: 30px;\n  margin-top: 1em;\n  background: #d8250d;\n  color: #ffffff;\n  cursor: pointer;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/online-casino-solution/online-casino-solution.component.css
// module id = ./src/app/components/online-casino-solution/online-casino-solution.component.css
// module chunks = main